export default class AppController {
  constructor(appModel, appServices) {
    "ngInject";
    this.appModel = appModel;
    this.appServices = appServices;
  }

  $onInit() {
    this.stylesheetReferences = this.appModel.stylesheetReferences;
  }
}



// WEBPACK FOOTER //
// ./client/app/app.controller.js